import url from '@/URL.js'
import axios from 'axios'
function verifyToken(err) {
    if(err.response.status === 401) {
        localStorage.removeItem('editorToken')
        router.push('/editor/login')
    }
}

export const namespaced = true
export const state = {
    token : localStorage.getItem('userToken'),
    loading:false,
    error:'',
    success:'',
    agreements:[],
    approvedAgreements:[],
    categories:[]
}

export const mutations = {
     ADD_CATEGORIES(state, categories) {
        state.categories = categories
     },
    LOADING(state, request) {
        state.loading = request
    },
    ERROR(state, request) {
        state.error = request
        setTimeout(function( ){
            state.error = null
         },2000)
    },
    SUCCESS(state,request) {
        state.success = request
        setTimeout(function( ){
            state.success = null
         },2000)
    },
    ADD_USER_AGGREEMENTS(state, agreement) {
        state.agreements = agreement
    },
    DELETE_USER_AGGREEMENT(state, {id, key}) {
        state.categories.splice(key,1)
    },
    ADD_APPROVED_AGGREEMENTS(state, agreements) {
        state.approvedAgreements = agreements
    }
    
   }

export const actions = {
    async getCategories({commit}){
          try {
              const {data, status} = await axios.get(`${url()}/api/actioncommons/categories`)
              if(status === 200) {
                  commit('ADD_CATEGORIES', data)
              }
    
          } catch( err) {
              if(err.response.status === 400){
                  commit('ERROR','An Error Occured Try Again!')
              }
          }
          
      },
   async submitAgreement({commit}, file) {
       commit('LOADING', true)
        // console.log('file', [...file])
       try {
        axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('userToken')}`;
        const {status,data} = await axios.post(`${url()}/api/actioncommons/agreement/submit`, file)
        console.log('data', data)
        if(status === 200) {
            commit('LOADING', false)
            commit('SUCCESS', 'Your submission have been accepted')
        }

    }catch( err ) {
        console.log(err)
        commit('LOADING', false)
        verifyToken(err)
    }

},
//get use agreements
async getUserAgreements({commit}) {
    commit('LOADING', true)
    console.log('user toke', localStorage.getItem('userToken'))
    try {
        axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('userToken')}`;
     const {status, data} = await axios.get(`${url()}/api/actioncommons/agreements/contributor`)

     if(status === 200) {
         commit('LOADING', false)
         commit('ADD_USER_AGGREEMENTS',data.agreements)
         
     }

 }catch( err ) {
    commit('LOADING', false)
     console.log(err)
 }
},
//delete user submissions
async deleteAgreement({commit}, {id, key}) {
    commit('LOADING', true)

    try {

     const {status, data} = await axios.delete(`${url()}/api/actioncommons/agreement/${id}` ,{
         headers: {
             Authorization: `${localStorage.getItem('userToken')}`
         }
     })

     if(status === 200) {
         commit('LOADING', false)
         commit('DELETE_USER_AGGREEMENT',id)
         commit('SUCCESS','Your submission have been deleted successfully')
     }

 }catch( err ) {
     console.log(err)
     verifyToken(err)
     commit('LOADING', false)
 }
},
async getApprovedAgreements({commit}) {
    commit('LOADING', true)

    try {

     const {status, data} = await axios.get(`${url()}/api/actioncommons/agreements` ,{

     })

     if(status === 200) {
         commit('LOADING', false)
         commit('ADD_APPROVED_AGGREEMENTS',data.agreements)
         
     }

 }catch( err ) {
     console.log(err)
     commit('LOADING', false)
 }
},        
       
   
}